export default __webpack_public_path__ + "static/media/light3.e32544f9.svg";